import { useEffect, useState } from 'react';
import { FiArrowUp } from 'react-icons/fi';
import './back-to-top.css';

const BackToTop = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 600);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollUp = () => {
    const reduced =
      typeof window.matchMedia !== 'function' ||
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: 0, behavior: reduced ? 'auto' : 'smooth' });
    /* Return focus to the top of the document, not just the viewport —
       otherwise a keyboard user's next Tab continues from the bottom. */
    document.getElementById('main-content')?.focus({ preventScroll: true });
  };

  return (
    <button
      type="button"
      className={`back-to-top${visible ? ' is-visible' : ''}`}
      onClick={scrollUp}
      // Kept out of the tab order while off-screen so it is never a
      // focusable-but-invisible target.
      tabIndex={visible ? 0 : -1}
      aria-hidden={!visible}
    >
      <FiArrowUp aria-hidden="true" />
      <span className="sr-only">Back to top of page</span>
    </button>
  );
};

export default BackToTop;
